import React, { createContext, useState } from 'react';

export const CountryContext = createContext();

export const CountryProvider = ({ children }) => {
   const [selectedCountry, setSelectedCountry] = useState(null);
   const [CountryName, setCountryName] = useState('');

   return (
      <CountryContext.Provider value={{ selectedCountry, setSelectedCountry, CountryName, setCountryName }}>
         {children}
      </CountryContext.Provider>
   );
};
